import { makeVar } from '@apollo/client'
import { User } from '@deltek/specification-client/core/Models/user'

export interface UserStateType extends User {
    fullName: string
    profileInfo: Record<string, string>
    professionalDiscipline: string
    professionalRole: string
    title: string
    imageUrl: string
}

export const usersReactiveVar = makeVar<Record<string, UserStateType>>({})

export const setUsers = (users: any) => {
    const formattedUsers = users.reduce(
        (
            acc: Record<string, Partial<UserStateType>>,
            {
                id = '',
                email = '',
                role,
                profileInfo = {},
                professionalDiscipline = '',
                professionalRole = '',
                title = '',
                imageUrl = '',
            }: Partial<UserStateType>
        ) => {
            acc[id] = {
                id,
                email,
                role,
                fullName: `${
                    (profileInfo as Record<string, string>)?.firstName ?? ''
                } ${(profileInfo as Record<string, string>)?.lastName ?? ''}`,
                profileInfo,
                professionalDiscipline,
                professionalRole,
                title,
                imageUrl,
            }

            return acc
        },
        {}
    )

    usersReactiveVar(formattedUsers)
}

export const getUsersList = () => Object.values(usersReactiveVar())
export const getUsersObject = () => usersReactiveVar()
export const getUserObject = (userId: string) => {
    return usersReactiveVar()[userId] ?? {}
}
export const getUsersCount = () => Object.keys(usersReactiveVar()).length
